<app-modal [modalTitleText]="headerText" [cancelButtonText]="closeText" [primaryButtonEnabled]="false" (cancelButtonAction)="closeModal()">
  <app-contact-us modal-content></app-contact-us>
</app-modal>
